import React from 'react';

import Colors from './Colors/Colors';
import ColorsUsage from './Colors/ColorsUsage';

import Icons from './Icons/Icons';
import IconsUsage from './Icons/IconsUsage/IconsUsage';

import Illustrations from './Illustrations/Illustrations';
import IllustrationsUsage from './Illustrations/IllustrationsUsage/IllustrationsUsage';

import MotionUsage from './Motion/MotionUsage';

import TextStyles from './TextStyles/TextStyles';
import TextStylesUsage from './TextStyles/TextStylesUsage/TextStylesUsage';

import Grids from './Grids/Grids';
import GridsUsage from './Grids/GridsUsage/GridsUsage';

/* eslint-disable react/display-name */
const Foundations = {
  Colors: () => <Colors />,
  ColorsUsage: () => <ColorsUsage />,

  Icons: () => <Icons />,
  IconsUsage: () => <IconsUsage />,

  Illustrations: () => <Illustrations />,
  IllustrationsUsage: () => <IllustrationsUsage />,

  MotionUsage: () => <MotionUsage />,

  TextStyles: () => <TextStyles />,
  TextStylesUsage: () => <TextStylesUsage />,

  Grids: () => <Grids />,
  GridsUsage: () => <GridsUsage />,
};

export default Foundations;



// WEBPACK FOOTER //
// ./src/containers/foundations/index.js